import { Card } from "@mui/material";
import { Border, Surface } from "@chemaxon/design-system/color";

export const BaseCard = props => (
  <Card
    variant="outlined"
    sx={{
      backgroundColor: Surface.variant,
      borderColor: Border.variant.main,
      borderRadius: 2,
    }}
    {...props}
  />
);
